// extracted by mini-css-extract-plugin
export default {"NoticeCorrect":"NoticeCorrect_NoticeCorrect__vnV0S"};